"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M11 2.5c2.064 0 4.065.603 5.788 1.743a.501.501 0 0 1-.552.834A9.463 9.463 0 0 0 11 3.5c-5.238 0-9.5 4.262-9.5 9.5s4.262 9.5 9.5 9.5 9.5-4.262 9.5-9.5a9.455 9.455 0 0 0-1.577-5.236.5.5 0 0 1 .834-.552A10.448 10.448 0 0 1 21.5 13c0 5.79-4.71 10.5-10.5 10.5S.5 18.79.5 13 5.21 2.5 11 2.5Zm0 4c.97 0 1.911.215 2.797.639a.5.5 0 0 1-.432.902A5.439 5.439 0 0 0 11 7.5 5.506 5.506 0 0 0 5.5 13c0 3.033 2.468 5.5 5.5 5.5s5.5-2.467 5.5-5.5c0-.819-.183-1.615-.542-2.366a.5.5 0 0 1 .902-.432c.425.887.64 1.828.64 2.798 0 3.584-2.916 6.5-6.5 6.5A6.508 6.508 0 0 1 4.5 13c0-3.584 2.916-6.5 6.5-6.5ZM21.191.539a.5.5 0 0 1 .31.462v1.5H23a.5.5 0 0 1 .353.854l-2 2A.499.499 0 0 1 21 5.5h-1.793l-6.121 6.122c.261.395.414.869.414 1.377 0 1.378-1.121 2.5-2.5 2.5A2.503 2.503 0 0 1 8.5 13c0-1.378 1.121-2.5 2.5-2.5.51 0 .984.153 1.38.416l6.12-6.122V3c0-.133.053-.26.146-.354l2-2a.498.498 0 0 1 .545-.108ZM11 11.5c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5a1.502 1.502 0 0 0 1.354-2.145l-1 1a.498.498 0 0 1-.708 0 .5.5 0 0 1 0-.707l1.001-1.001A1.492 1.492 0 0 0 11 11.5Zm9.5-9.292-1 1V4.5h1.293l1-1H21a.5.5 0 0 1-.5-.5v-.793Z",
    clipRule: "evenodd"
  })]
});